import React from 'react';
import classNames from 'classnames';

import { useGetClientHcpUnspentFundsQuery } from '~support-at-home/actions/clientHcpUnspentFunds';

interface ComponentProps {
  allocated: number;
  available: number;
  client_id?: number;
}

const currencyFormatter = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const BudgetTotalIndicator: React.FC<ComponentProps> = React.memo(({ allocated, available, client_id }) => {
  const isOver = allocated > available;
  const className = classNames('budget-total-indicator', {
    'over-budget': isOver,
  });
  const { data, isLoading, isError } = useGetClientHcpUnspentFundsQuery(
    { client_id },
    { skip: !client_id, refetchOnMountOrArgChange: true },
  );
  const provider_held = data?.provider_held ?? 0;
  const commonwealth_held = data?.commonwealth_held ?? 0;
  const client_held = data?.client_held ?? 0;

  return (
    <div className={className}>
      {!isLoading && !isError && (
        <div className="hcp_unspent_funds">
          <div className="label">HCP Unspent Funds</div>
          <div className="hcp_unspent_funds_details">
            <div className="label">Provider Held:</div>
            <span className="currency-value">{currencyFormatter.format(provider_held)}</span>
            <div className="label">Commonwealth Held:</div>
            <span className="currency-value">{currencyFormatter.format(commonwealth_held)}</span>
            <div className="label">Client Held:</div>
            <span className="currency-value">{currencyFormatter.format(client_held)}</span>
          </div>
        </div>
      )}
      <div>
        <div className="totals">
          <div className="label">Allocated Budget:</div>
          <span className="currency-value">{currencyFormatter.format(allocated)}</span>
          <div className="label">Available Budget:</div>
          <span className="currency-value">{currencyFormatter.format(available)}</span>
        </div>
        <div className="gst-info-caption text-end">All prices budgeted are considered GST Exclusive</div>
      </div>
    </div>
  );
});

BudgetTotalIndicator.displayName = 'BudgetTotalIndicator';
export default BudgetTotalIndicator;
